<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="table-responsive">
                    <div id="ses-list" class="list-proj">
                        <div class="row list-head">
                            <div class="col" data-key="username">Name</div>
                            <div class="col" data-key="title">Title</div>
                            <div class="col" data-key="company">Company</div>
                            <div class="col" data-key="telephone">Telephone</div>
                            <div class="col" data-key="email">Email</div>
                            <div class="col" data-key="companytype">Company Type</div>
                            <div class="col" data-key="companytype">Date</div>
                        </div>
                        <div class="list-row" v-for="(row, key) in inquiries" :key="key">
                            <div class="row list-data">
                                <div class="col">{{ row.Name }}</div>
                                <div class="col">{{ row.Title }}</div>
                                <div class="col">{{ row.Company }}</div>
                                <div class="col">{{ row.Telephone }}</div>
                                <div class="col">{{ row.Email }}</div>
                                <div class="col">{{ row['Company Type'] }}</div>
                                <div class="col">{{ row.Date }}</div>
                            </div>
                        </div>
                    </div>
                    <template v-if="inquiries.length == 0 && !isListLoading">
                        <p class="no-results-msg">No results found</p>
                    </template>
                    <template v-if="isListLoading">
                        <div class="progress">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-12">
                <div class="button-group">
                    <a class="btn btn-black" :href="`/api/inquiries/export`" data-export>Export Inquiries</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'inquiries',
    data() {
        return {
            apiUrl: '/api/',
            inquiries: [],
            isListLoading: false,
            page: 1,
            last_page: 1,
            order_by: 'date',
            order: 'asc',
            filters: {
                search: '',
                company: 'all',
                role: 'all'
            },
            companies: [],
            roles: [],
            default_select_all_user: false,
            selected_users: [],
            select_all_user_filters: [],
            showBulkEditModal: false
        }
    },
    mounted() {
        // let def_order = document.querySelector('#ses-list .list-head .col[data-key='+this.order_by+']')
        // def_order.classList.add(this.order)
        // def_order.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
        // this.loadUsers()
    },
    methods: {
        loadUsers() {
            var user = localStorage.getItem('user');
            if ( !user ) this.$router.push('login');
            this.user = JSON.parse(user);

            const api = this.apiUrl+'inquiries/list';

            this.isListLoading = true;
            this.$http.get(api).then((response) => {
                this.inquiries = [];
                response.data.inquiries.forEach(row => {
                    this.inquiries.push(row);
                })
                this.isListLoading = false;
            });
        }
    },
    beforeMount(){
        this.loadUsers()
    }
};
</script>
<style lang="scss" scoped>
#ses-list {
    min-width: 700px;
    padding-right: 12px;
    max-height: 500px;
    .list-head .col {
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url('/api/public/img/bgx.png');
        background-position: center right;
        background-repeat: no-repeat;
        cursor: pointer;
        white-space: normal;
        &.asc {
            background-image: url('/api/public/img/trans-asc.png');
        }
        &.desc {
            background-image: url('/api/public/img/trans-desc.png');
        }
        &.sort-false {
            background-image: none;
            cursor: default;
        }
    }
}
.progress {
    border-radius: 0;
}
.no-results-msg {
    text-align: center;
    padding: 0.5em;
    font-size: 11px;
}
.col-check-th,
.col-check-td {
    flex-grow: 0;
}
.col-check-th {
    padding-left: 32px;
}
.col-check-td {
    padding-left: 25px;
}
.btnDeselectAllUser {
    background-color: #c90000;
    color: #fff;
    font-size: 11px;
    border-radius: 50%;
    height: 24px;
    width: 24px !important;
    padding: 0;
    position: absolute;
    z-index: 10;
    right: -14px;
    top: -9px;
    &:hover {
        color: #000;
    }
}
.button-group {
    .btn-bulk-edit {
        width: 100%;
        margin-right: 0;
        .btn {
            width: 100%;
        }
    }
}
@media (min-width: 568px) {
    .button-group {
        .btn-bulk-edit {
            width: 48%;
            margin-right: 8px;
        }
    }
}
@media (min-width: 992px) {
    .button-group {
        .btn-bulk-edit {
            width: auto;
        }
    }
}
@media (max-width: 768px) {
    #ses-list {
        min-width: 1200px;
    }
}
</style>
